import { FormGroup } from "@angular/forms";
import { JobAddressSelection } from "../../Jobbing/models/JobAddressSelection";
import { JobTypeEnum } from "../enum/JobTypeEnum";
import { ContainerJobContact } from "../model/ContainerJobContact";
import { JobManualBillingEnum } from "../model/JobManualBillingEnum";
import { CreateContainerJobRequest } from "../model/CreateContainerJobRequest";
import { CreateContainerJobRequestItem } from "../model/CreateContainerJobRequestItem";
import { CreateContainerJobRequestPortData } from "../model/CreateContainerJobRequestPortData";
import { GoogleMapsService } from "../../google-maps/google-maps.service";
import { NgbDate } from "@ng-bootstrap/ng-bootstrap";
import { HazardCode } from "../model/HazardCode";

export class CreateContainerJobRequestFactory {
  buildContainerJobRequest(formGroup: FormGroup, containerItems: any[], googleAddressService: GoogleMapsService): CreateContainerJobRequest {
    const formValue = formGroup.value;
    let createRequest = new CreateContainerJobRequest();
    createRequest.clienteleId = formValue.containerBasics.freightPayer.clienteleId;
    createRequest.tswId = formValue.containerBasics.tswId;
    createRequest.ecn = formValue.containerBasics.ecn;
    createRequest.jobTypeCode = formValue.containerBasics.jobType.id;
    createRequest.billingDivisionId = formValue.containerBasics.billingDivision.regionId;
    createRequest.divisionId = formValue.division.regionId;
    createRequest.fromAddress = this.extractAddress(formValue.fromAddress, googleAddressService);
    createRequest.fromJobContact = this.extractSiteContact(formValue.fromAddress);

    createRequest.toAddress = this.extractAddress(formValue.toAddress, googleAddressService);
        createRequest.toJobContact = this.extractSiteContact(formValue.toAddress);

        createRequest.portData = this.buildRequestPortData(formValue.portData, createRequest.jobTypeCode);

        let containers: CreateContainerJobRequestItem[] = [];

        containerItems.forEach(itemData => {
            const containerData = itemData.data;
            const containerItemRequest = this.buildContainerItemRequest(formValue, containerData, createRequest);
            if (containerItemRequest) {
                containers.push(containerItemRequest);
            }
        });

        createRequest.containers = containers;
        createRequest.attachments = [];
        createRequest.bacc = [];
        return createRequest;
    }

    extractSiteContact(source: any): ContainerJobContact | null {
        if (source.siteContact || source.siteEmail || source.sitePhone){
            return {
                jobContactId: 0,
                name: source.siteContact,
                email: source.siteEmail,
                phone: source.sitePhone
            }
        }
        return null;
    }

  extractAddress(source: any, googleAddressService: GoogleMapsService): any | null {
        if (source?.address?.addressSelection) {
          if (source?.address?.addressSelection.isCreateMode) {
            return {
              name: source.address.addressSelection.addressName,
              address: googleAddressService.getAddressLineFromAddressComponents(source.address.addressSelection.addressDetails.addressComponents),
              latitude: source.address.addressSelection.addressDetails.lat,
              longitude: source.address.addressSelection.addressDetails.lng,
              masterContactId: 0,
            };
          } else if (source?.address?.addressSelection) {
            return {
              masterContactId: source.address.addressSelection.masterContactAddressId.masterContactId,
              name: source.address.addressSelection.masterContactAddressId.masterContactName,
              address: "",
              latitude: 0,
              longitude: 0
            }
          }
        }

        return null;
    }

    buildRequestPortData(formData: any, jobType: JobTypeEnum): CreateContainerJobRequestPortData | null {
      if (formData === null || (jobType === JobTypeEnum.MoveMt || jobType === JobTypeEnum.MoveFull || jobType === JobTypeEnum.OnSite)) {
        return null;
      }

      if (this.isRailJobType(jobType)) {
        return this.buildRailTerminalPortData(formData);
      }

      let portData = new CreateContainerJobRequestPortData();
      portData.seaPortCode = formData.originPort.code;
      if (formData.isUsingInlandPort) {
        portData.useInlandPort = true;
      }
      else {
        portData.useInlandPort = false;
      }

      if (portData.useInlandPort && formData.onwardPort) {
        portData.inlandPortCode = formData.onwardPort.code;
      }

      if (formData.vessel) {
        portData.scheduledVesselVisitId = formData.vessel.scheduledVesselVisitId;
        portData.vesselCode = formData.vessel.vesselName;
      }

      if ((formData.toEtaEtdDate !== null && formData.toEtaEtdDate !== undefined)
        || (formData.fromEtaEtdDate !== null && formData.fromEtaEtdDate !== undefined)) {
        portData.vesselEta = formData.fromEtaEtdDate?.toISOString();
        portData.vesselEtd = formData.toEtaEtdDate?.toISOString();
      }

      portData.receivalCommenceDate = formData.receivalCommenceDate;
      portData.receivalCutoffDate = formData.receivalCutoffDate;
      return portData;
    }

    isRailJobType(jobType: JobTypeEnum): boolean {
        if (jobType === JobTypeEnum.RailInbound ||
            jobType === JobTypeEnum.RailOutbound ||
            jobType === JobTypeEnum.IntermodalRail) {
            return true;
        }
        return false;
    }

    isInboundJobType(jobType: JobTypeEnum): boolean {
        if (jobType === JobTypeEnum.Import ||
            jobType === JobTypeEnum.DomesticInbound ||
            jobType === JobTypeEnum.RailInbound) {
            return true;
        }
        return false;
    }

    isOutboundJobType(jobType: JobTypeEnum): boolean {
        if (jobType === JobTypeEnum.Export ||
            jobType === JobTypeEnum.DomesticOutbound ||
            jobType === JobTypeEnum.RailOutbound) {
            return true;
        }
        return false;
    }

    isIntermodalJobType(jobType: JobTypeEnum): boolean {
        if (jobType === JobTypeEnum.IntermodalCoastal ||
            jobType === JobTypeEnum.IntermodalRail) {
            return true;
        }
        return false;
    }

    buildRailTerminalPortData(formData: any): CreateContainerJobRequestPortData {
        // For rail jobs, use the inland port field.
        let portData = new CreateContainerJobRequestPortData();
        portData.useInlandPort = true;
        portData.inlandPortCode = formData.originPort.code;

        if (formData.vessel) {
            portData.vesselCode = formData.vessel.vesselName;
        }

      portData.vesselEta = formData.fromEtaEtdDate?.toISOString();
      portData.vesselEtd = formData.fromEtaEtdDate?.toISOString();

        return portData;
    }

  getDateFromNgbObject(date: NgbDate) {
    if (!date) {
      return null;
    }
    return new Date(date.year, date.month - 1, date.day);
  }

    buildContainerItemRequest(formValue: any, containerData: any, createRequest: CreateContainerJobRequest)
        : CreateContainerJobRequestItem | null {
      if (formValue === null || containerData === null) {
        return null;
      }

      let itemRequest = new CreateContainerJobRequestItem();

      itemRequest.containerNumber = containerData.containerNumber;
      itemRequest.weightKg = containerData.weight;
      itemRequest.containerSizeCode = containerData.containerSize;
      itemRequest.containerTypeCode = containerData.containerType;
      itemRequest.temperature = formValue.containerBasics.temperatureValue;
      itemRequest.isHighGauge = containerData.isHighGauge;
      itemRequest.isWideGauge = containerData.isWideGauge;
      itemRequest.orderNumber = formValue.containerBasics.orderNumber;
      itemRequest.fullRequestedDeliveryDate = this.getDateFromNgbObject(formValue.portData.fullRequestedDeliveryDate);
      itemRequest.customerReference = formValue.containerBasics.customerReference;
      itemRequest.csrComments = formValue.containerBasics.csrComments;
      itemRequest.billingNotes = formValue.containerBasics.billingNotes;
      itemRequest.driverNotes = formValue.driverNotes;
      itemRequest.requiresXray = containerData.requiresXray;
      itemRequest.requiresWeigh = containerData.requiresWeigh;
      itemRequest.fullLegGridNumber = containerData.gridNumberFull;
      itemRequest.mtLegGridNumber = containerData.gridNumberMt;

      if (formValue.fromAddress) {
        itemRequest.plannedLoadDate = formValue.fromAddress.loadDate;
      }

      if (formValue.isDevan) {
        const value = this.getDateFromNgbObject(formValue.plannedDevanDate);

        if (value) {
          itemRequest.plannedDevanDateUtc = value;
        }

        itemRequest.plannedDevanType = formValue.plannedDevanType.name;
      }

      if (formValue.isPack) {
        const plannedPackDateUtc: NgbDate | null = formValue.plannedPackDate;
        itemRequest.plannedPackDateUtc = plannedPackDateUtc ? new Date(plannedPackDateUtc.year, plannedPackDateUtc.month, plannedPackDateUtc.day) : null;
        itemRequest.plannedPackType = formValue.plannedPackType.name;
      }

      itemRequest.doorDirectionCode = containerData.doorDirection;
      itemRequest.fullLegOnly = formValue.containerBasics.fullLegOnly;

      if (!itemRequest.fullLegOnly) {
        itemRequest.fullLegOnly = false;
      }

      itemRequest.storageDays = containerData.storageDays;

      if (formValue.depotHub) {
        const hubData = formValue.depotHub;
        if (hubData.mtLocation) {
          itemRequest.emptyContainerDepotCode = hubData.mtLocation.code;
          itemRequest.emptyContainerDepotContainerPortId = hubData.mtLocation.containerPortId
        }

        itemRequest.emptyContainerAccessCode = hubData.releaseAcceptNo;

        itemRequest.pin = containerData.pin;
        itemRequest.expressPin = containerData.expressPin;

        if (hubData.inboundHub && hubData.inboundHub.selectedParkId !== 0) {
          itemRequest.inboundHubId = hubData.inboundHub.selectedParkId;
        } else {
          delete itemRequest.inboundHubId;
        }

        if (hubData.outboundHub && hubData.outboundHub.selectedParkId !== 0) {
          itemRequest.outboundHubId = hubData.outboundHub.selectedParkId;
        } else {
          delete itemRequest.outboundHubId;
        }

        itemRequest.mtRequestedDeliveryDate = this.getDateFromNgbObject(formValue.depotHub.mtRequestedDeliveryDate);
      }

      if (formValue.intermodalDepotHub) {
        let hubData = formValue.intermodalDepotHub;

        if (hubData.mtLocation) {
          itemRequest.emptyContainerIntermodalDepotCode = hubData.mtLocation.code;
          itemRequest.emptyContainerIntermodalDepotContainerPortId = hubData.mtLocation.containerPortId;
        }

        itemRequest.emptyContainerIntermodalAccessCode = hubData.releaseAcceptNo;

        if (hubData.inboundHub && hubData.inboundHub.containerHubId !== 0) {
          itemRequest.inboundIntermodalHubId = hubData.inboundHub.containerHubId;
        } else {
          delete itemRequest.inboundIntermodalHubId;
        }

        if (hubData.outboundHub && hubData.outboundHub.containerHubId !== 0) {
          itemRequest.outboundIntermodalHubId = hubData.outboundHub.containerHubId;
        } else {
          delete itemRequest.outboundIntermodalHubId;
        }

        itemRequest.intermodalMtRequestedDeliveryDate = formValue.intermodalDepotHubData.mtRequestedDeliveryDate;
      }

      itemRequest.unloadTypeCode = formValue.containerBasics.loadUnloadType.code;
      itemRequest.sealNumber = containerData.seal;
      itemRequest.mpiInspectionRequired = formValue.containerBasics.mpiInspectionRequired;
      itemRequest.needsLift = formValue.containerBasics.needsLift;

      if (containerData.dangerousGoods) {
        containerData.dangerousGoods.forEach((dgClass: any) => {
          itemRequest.dangerousGoodClasses.push({ id: dgClass, alias: dgClass.alias, name: dgClass.name })
        });
      }

      itemRequest.fromAddress = createRequest.fromAddress;
      itemRequest.toAddress = createRequest.toAddress;
      itemRequest.portData = createRequest.portData;
      itemRequest.intermodalPortData = createRequest.intermodalPortData;
      if (formValue.intermodalToPortData) {
        itemRequest.intermodalFullRequestedDeliveryDate = formValue.intermodalToPortData.fullRequestedDeliveryDate;
      }

      const containerCharges = formValue.containerCharges;
      if (containerCharges && containerCharges.chargeType === JobManualBillingEnum.Manual) {
        itemRequest.useManualRating = true;
        itemRequest.manualRating = {
          description: containerCharges.description,
          ratePerContainer: containerCharges.ratePerContainer,
          fafRate: containerCharges.fafRate,
        }
      }

      itemRequest.surcharges = formValue.containerSurcharges.surcharges;

      return itemRequest;
    }
}
